import cx from 'classnames'
import CommonTable from '../Table'
import styles from './PieTable.css'

const PieTable = props => {
  const { className, ...restProps } = props
  return (
    <CommonTable
      sortable={false}
      resizable={false}
      showPagination={false}
      className={cx(
        styles.resultTable,
        { [props.className]: className }
      )}
      noBorder
      noStripe
      {...restProps}
    />
  )
}

export default PieTable
